import React from 'react'
import classNames from 'classnames'

function Text({ text, size = "1", className, mandatoryElement, htmlFor, labelClassname, classNameOtherElement, nameOtherElement,
  onChangeOtherElement, typeOtherElement, valueOtherElement, style, href, secText, horizontal, typeFormElement, textAfterMandatory, initialTextBold, infoLabel }) {

  return (
    <div className={classNames(
      'cge-text',
      {
        'cge-text__info-label': infoLabel,
      }
    )}>
      {text && size === "1" &&
        <p
          className={"p-normal " + className}
          htmlFor={htmlFor}
          style={style}
        >
          {initialTextBold &&
            <span className='font-weight-bold'>{initialTextBold}&nbsp;</span>
          }
          {text}{secText} {mandatoryElement ? <b class="text-danger">*</b> : ''}
          {textAfterMandatory && <span style={{ fontSize: '14px', fontWeight: 500 }}>
            &nbsp;{textAfterMandatory}
          </span>}
        </p>
      }

      {text && size === "2" &&
        <p
          className={"p-small " + className}
          htmlFor={htmlFor}
          style={style}
        >
          {initialTextBold &&
            <span className='font-weight-bold'>{initialTextBold}&nbsp;</span>
          }
          {text}{secText} {mandatoryElement ? <b class="text-danger">*</b> : ''}
          {textAfterMandatory && <span style={{ fontSize: '14px', fontWeight: 500 }}>
            &nbsp;{textAfterMandatory}
          </span>}
        </p>
      }

      {text && size === "3" &&
        <p
          className={"p-larger " + className}
          htmlFor={htmlFor}
          style={style}
        >
          {initialTextBold &&
            <span className='font-weight-bold'>{initialTextBold}&nbsp;</span>
          }
          {text}{secText} {mandatoryElement ? <b class="text-danger">*</b> : ''}
          {textAfterMandatory && <span style={{ fontSize: '14px', fontWeight: 500 }}>
            &nbsp;{textAfterMandatory}
          </span>}
        </p>
      }

      {text && size === "4" &&
        <p
          className={classNames(
            "p-label " + className,
            {
              'p-label-margin-top': horizontal && typeFormElement !==  ("checkbox" || "radio"),
            }
          )}
          htmlFor={htmlFor}
          style={style}
        >
          {initialTextBold &&
            <span className='font-weight-bold'>{initialTextBold}&nbsp;</span>
          }
          {text}{secText} {mandatoryElement ? <b class="text-danger">*</b> : ''}
          {textAfterMandatory && <span style={{ fontSize: '14px', fontWeight: 500 }}>
            &nbsp;{textAfterMandatory}
          </span>}
        </p>
      }

      {text && size === "5" &&
        <p
          className={"p-table-label " + className}
          htmlFor={htmlFor}
          style={style}
        >
          {initialTextBold &&
            <span className='font-weight-bold'>{initialTextBold}&nbsp;</span>
          }
          {text}{secText} {mandatoryElement ? <b class="text-danger">*</b> : ''}
          {textAfterMandatory && <span style={{ fontSize: '14px', fontWeight: 500 }}>
            &nbsp;{textAfterMandatory}
          </span>}
        </p>
      }

      {text && size === "6" &&
        // Use size === 6 of the global text component when passing any type of input that is not text type. Implemented so far the radio type
        <label className={labelClassname}>
          <p
            className={"p-label-w-other-element " + className}
            htmlFor={htmlFor}
            style={style}
          >
            {typeOtherElement === 'radio' ?
              <input
                className={classNameOtherElement}
                name={nameOtherElement}
                onChange={onChangeOtherElement}
                type={typeOtherElement}
                value={valueOtherElement}
              />
              : ''}
            {initialTextBold &&
              <span className='font-weight-bold'>{initialTextBold}&nbsp;</span>
            }
            {text}{secText} {mandatoryElement ? <b class="text-danger">*</b> : ''}
            {textAfterMandatory && <span style={{ fontSize: '14px', fontWeight: 500 }}>
              &nbsp;{textAfterMandatory}
            </span>}
          </p>
        </label>
      }

      {text && size === "7" &&
        <a
          href={href}
          className={"p-normal " + className}
          htmlFor={htmlFor}
          style={style}
        >
          {initialTextBold &&
            <span className='font-weight-bold'>{initialTextBold}&nbsp;</span>
          }
          {text}{secText} {mandatoryElement ? <b class="text-danger">*</b> : ''}
          {textAfterMandatory && <span style={{ fontSize: '14px', fontWeight: 500 }}>
            &nbsp;{textAfterMandatory}
          </span>}
        </a>
      }

      {text && size === "8" &&
        <a
          href={href}
          className={"p-small " + className}
          htmlFor={htmlFor}
          style={style}
        >
          {initialTextBold &&
            <span className='font-weight-bold'>{initialTextBold}&nbsp;</span>
          }
          {text}{secText} {mandatoryElement ? <b class="text-danger">*</b> : ''}
          {textAfterMandatory && <span style={{ fontSize: '14px', fontWeight: 500 }}>
            &nbsp;{textAfterMandatory}
          </span>}
        </a>
      }
    </div>
  )
}

export default Text;